import { ReactNode, useCallback } from "react";
import { SWRConfig, SWRConfiguration } from "swr";
import useApi from "~/hooks/contexts/useApi";
import useUserAuthentication from "~/hooks/contexts/useUserAuthentication";
import { SwrError } from "~/lib/swr";

export type SwrConfigProps = {
  children: ReactNode;
};

export default function SwrConfig({ children }: SwrConfigProps) {
  const { set: setUserAuthentication } = useUserAuthentication();
  const api = useApi();

  const fetcher: SWRConfiguration["fetcher"] = useCallback(async (endpoint: string, init?: RequestInit) => {
    let swrError: SwrError | null = null;
    let responseJson: any = null;

    try {
      const response = await api.get(endpoint, init);
      responseJson = await response.json();

      if (!response.ok) {
        if (response.status === 401) {
          setUserAuthentication((s) => ({ ...s, user: null, userAccessToken: null }));
        }

        swrError = new SwrError(responseJson.detail, response.status);
      }
    } catch (error) {
      swrError = new SwrError("An error occurred while connecting to API.", error);
    }

    if (swrError !== null) {
      throw swrError;
    }

    return responseJson;
  }, [api, setUserAuthentication]);

  return (
    <SWRConfig value={{ fetcher }}>
      {children}
    </SWRConfig>
  );
}
